import { makeStyles } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import tomtomLogo from '../../images/tomtomLogo.svg';
import tomtomLogoLight from '../../images/tomtomLogoLight.svg';

const useStyles = makeStyles({
  logo: {
    width: 'auto',
    height: 30,
    display: 'block',
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  const theme = useTheme();
  const logoSrc = theme.palette.type === 'light' ? tomtomLogoLight : tomtomLogo;

  return <img src={logoSrc} className={classes.logo} alt="TomTom" />;
};
